"use client";

import React from "react";
import { Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function SobreNos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = ["1999 nos tornamos canal de vendas e serviços Millennium NetWork.", "2019 nos tornamos Franquia Linx na aquisição de Millennium pela Linx.", "2025 - Passamos a fazer parte da maior empresa de software do Brasil a Totvs que compra a Linx."];
  return <section data-section-id="17724" id="nossa-história" ref={ref} className={cn("bg-background text-foreground py-16 md:py-24 transition-opacity duration-700 backdrop-blur-xl", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {}
          <div className="relative">
            <div className="relative rounded-xl border border-[hsla(0,0%,100%,0.1)] overflow-hidden shadow-[0_0_30px_rgba(0,0,0,0.3)]">
              <img src="https://linxvilavelha.com.br/wp-content/uploads/2026/03/Designer-8.png" alt="Linx logo" className="w-full h-auto object-cover aspect-square !bg-[hsl(0,0%,98%)]" />
              
            </div>
          </div>

          {}
          <div>
            <h2 className="text-4xl font-bold text-white mb-6 tracking-tight">
              Nossa História
            </h2>
            <p className="text-white/90 mb-6 leading-relaxed text-base font-sans">
              Com mais de 25 anos de mercado, a franquia Linx Vila Velha nasceu da paixão pela tecnologia e pelo varejo. Nossa missão é transformar a gestão das empresas através de soluções inteligentes, conectando negócios ao futuro e garantindo eficiência operacional em cada etapa da jornada.
            </p>
            <ul className="space-y-4">
              {benefits.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <Star className="w-5 h-5 text-[#FF007F] mt-1 shrink-0 fill-[#FF007F]" />
                  <span className="text-[#C0C0C0] font-sans text-base">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}